import React from 'react';
import { Avatar } from '@components/avatar';
import { HrDarkGrey, HrFlexContainer, HrParagraph } from '@components/styles/hr-styles';
import { ActivitiesImage } from '@components/activitiesImage';

export const Activities = ({ src, description, date, time, iconName, background }) => {
  return (
    <HrFlexContainer flexWrap='nowrap' alignItems='flex-start'>
      <div>
        {src && <Avatar src={src} />}
        {!src && <ActivitiesImage iconName={iconName} background={background} />}
      </div>
      <HrFlexContainer alignContent='space-between' gap='4px'>
        {description}
        <HrFlexContainer flexWrap='nowrap'>
          <HrFlexContainer width='auto' gap='2px'>
            <span className='hr-Calendar' style={{ color: HrDarkGrey }} />
            <HrParagraph color={HrDarkGrey}>{date}</HrParagraph>
          </HrFlexContainer>
          <HrFlexContainer width='auto' gap='2px'>
            <span className='hr-Clock' style={{ color: HrDarkGrey }} />
            <HrParagraph color={HrDarkGrey}>{time}</HrParagraph>
          </HrFlexContainer>
        </HrFlexContainer>
      </HrFlexContainer>
    </HrFlexContainer>
  );
};
